import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../store";
import { Meeting } from '../../../types/meetings'
import * as triplinkService from '../../../utils/triplinkService'
import { logout } from "../auth/authSlice";

interface MeetingState {
  body: Meeting[],
  updating: boolean,
}

export const fetchMeetings = createAsyncThunk(
  'meetings/fetchMeetings',
  async (params, {dispatch, getState}) => {
    const state: RootState = (getState() as RootState);
    const accessToken = state.accessToken.body;
    if(!accessToken) {
      throw new Error('Cannot fetchMeetings without accessToken')
    }
    const result = await triplinkService.getMyMeetings(accessToken);

    return result;
  }
)

const initialState: MeetingState = {
  body: [],
  updating: false,
}

const meetingsSlice = createSlice({
  name: 'meetings',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(logout, (state) => {
      state.body = []
      state.updating = false
    })
    .addCase(fetchMeetings.pending, (state, action) => {
      state.updating = true
    })
    .addCase(fetchMeetings.fulfilled, (state, action) => {
      state.body = action.payload
      state.updating = false
    })
    .addCase(fetchMeetings.rejected, (state, action) => {
      state.body = []
      state.updating = false
    })
  }
})

export const selectMeetings = (state: RootState) => state.meetings

export default meetingsSlice.reducer;